import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import ImageUpload from './ImageUpload';

interface Props extends BaseFieldProps {
	previewStyle?: React.CSSProperties;
}

const ImageUploadField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<ImageUpload previewStyle={props.previewStyle} />
		</BaseField>
	);
};

export default ImageUploadField;
